import { useEffect, useState } from 'react';
import './Navbar.css';
import { servicesData } from '../data/servicesData';

const links = [
  { href: '#/', label: 'Home' },
  { href: '#/about', label: 'About' },
  { href: '#/services', label: 'Services' },
  { href: '#/technologies', label: 'Technologies' },
  { href: '#/portfolio', label: 'Portfolio' },
  { href: '#/videos', label: 'Videos' },
  { href: '#/blog', label: 'Blog' },
  { href: '#/contact', label: 'Contact' },
];

export default function Navbar({ currentRoute = '' }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Site is permanently light-themed — no dark mode toggle.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu when the route changes
  useEffect(() => { setMenuOpen(false); }, [currentRoute]);

  const isActive = (href) =>
    href === '#/'
      ? (currentRoute === '' || currentRoute === '#/' || currentRoute === '#/home')
      : href === '#/blog'
      ? (currentRoute === href || currentRoute.startsWith('#/blog/'))
      : currentRoute === href;

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <a href="#/" className="logo">
        <img src="logo.png" alt="AerialRoot Services" />
      </a>
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {links.map(l => (
          l.href === '#/services' ? (
            <li key={l.href} className="nav-dropdown">
              <a href={l.href} className={isActive(l.href) ? 'active' : ''}>{l.label}</a>
              <ul className="nav-dropdown-menu">
                {servicesData.map(s => (
                  <li key={s.slug}>
                    <a href={`#/services/${s.slug}`}>{s.title}</a>
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <li key={l.href}>
              <a href={l.href} className={isActive(l.href) ? 'active' : ''}>{l.label}</a>
            </li>
          )
        ))}
      </ul>
      <a href="#/contact" className="nav-cta">Get Started →</a>
    </nav>
  );
}
